import { useTheme, CSSObject } from '@core-ui/react-stitch';

const itemCountAndClearAllCombinedStyles = (): CSSObject => {
  const theme = useTheme();

  return ({
    width: '100%',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    borderBottom: `1px solid ${theme.color.gray20}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 150,
  });
};

export default itemCountAndClearAllCombinedStyles;
